import React from 'react';
import ScrollableArea from '../../../../atomic/atomicComponentLibrary/utility/scrollableArea/ScrollableArea';
import { NewPlanListItem } from '../tradePlanHubListItem/NewPlanListItem';
import { TradePlanHubListItem } from '../tradePlanHubListItem/TradePlanHubListItem';
import style from './TradePlanDisplay.module.css';

type Props = {
  tradePlanIds: string[];
  selectedTradePlan: string;
  setSelectedTradePlan: (value: string) => void;
  addNewTradePlan?: boolean;
};

export const TradePlanDisplay = ({
  tradePlanIds,
  selectedTradePlan,
  setSelectedTradePlan,
  addNewTradePlan,
}: Props) => {
  return (
    <ScrollableArea
      border="1px white inset"
      horizontal={true}
      vertical={false}
      width="361px"
      height="300px"
      backgroundColor="black"
    >
      <ul className={style.ul}>
        {tradePlanIds.map((id, i) => (
          <TradePlanHubListItem
            lastItem={addNewTradePlan ? false : i === tradePlanIds.length - 1}
            previous={tradePlanIds[i - 1] ?? null}
            selectedTradePlan={selectedTradePlan}
            setSelectedTradePlan={setSelectedTradePlan}
            key={id}
            tradePlanId={id}
          />
        ))}
        {addNewTradePlan ? (
          <NewPlanListItem
            lastItem={true}
            previous={tradePlanIds[tradePlanIds.length - 1] ?? null}
            selectedTradePlan={selectedTradePlan}
            setSelectedTradePlan={setSelectedTradePlan}
          />
        ) : null}
      </ul>
    </ScrollableArea>
  );
};
